import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output,} from '@angular/core';
import {CommmCode} from '../../../../../utils/constante/CommonCode';
import {InscriptionAcheteurService} from '../../inscription-acheteur.service';
import {Acheteur} from '../../../../../domain/acheteur/acheteur';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-add-info-interlocuteur-unique',
    templateUrl: './add-info-interlocuteur-unique.component.html',
    styleUrls: ['./add-info-interlocuteur-unique.component.css'],
})
export class AddInfoInterlocuteurUniqueComponent implements OnInit {
    @Output() add = new EventEmitter<any>();
    @Input() isachteur = true;
    commmCode = CommmCode;
    form = this.formservice.addinterlocuteurInfo();

    constructor(
        private formservice: InscriptionAcheteurService,
        private cdref: ChangeDetectorRef
    ) {
    }

    get(key: keyof Acheteur) {
        return this.form.get(key) as FormControl;
    }

    ngOnInit(): void {
    }

    next() {
        this.add.emit(this.form.value);
    }
}
